import { PlusOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Form, Input, message } from 'antd';
import { useState, useEffect } from 'react';
import 'react-phone-input-2/lib/style.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { fetchPackigModeById, updatePackingMode } from '../../slices/packing';

function EditPackingMode() {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [editorValue, setEditorValue] = useState('');
  const { loading } = useSelector(state => state.packingMode);

  useEffect(() => {
    const fetchPackingData = async () => {
      try {
        dispatch(fetchPackigModeById(id))
          .unwrap()
          .then(response => {
            if (response) {
              const packingData = response.data;
              const formValues = {
                name: packingData?.name,
              };
              setEditorValue(packingData?.description);
              form.setFieldsValue(formValues);

            }
          })
          .catch(error => {
            console.error('');
          });
      } catch (error) {
        console.error('');
      }
    };

    fetchPackingData();
  }, [id]);

  const handleChange = value => {
    setEditorValue(value);
  };

  const handleFinish = values => {
    dispatch(updatePackingMode({ id: id, values }))
      .unwrap()
      .then(result => {
        if (result.success) {
          message.success('Packing Mode Created Successfully!');
          navigate('/packing-mode');
        }
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Edit Packing Mode</h2>
          <div className="bredcrumbwrp">
            <Link to="/packing-mode" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/packing-mode">Packing Mode</Link> },
                { title: 'Edit Packing Mode' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          form={form}
          onFinish={handleFinish}
          autoComplete="off"
        >
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: 'Please enter alloy name!' }]}
          >
            <Input
              placeholder="Enter Packing Name"
            />
          </Form.Item>

          <Form.Item name="description" label="Description" valuePropName="content">
            <ReactQuill
              value={editorValue}
              onChange={handleChange}
              theme="snow"
              modules={{
                toolbar: [
                  [{ header: '1' }, { header: '2' }, { font: [] }],
                  [{ list: 'ordered' }, { list: 'bullet' }],
                  ['bold', 'italic', 'underline'],
                  [{ align: [] }],
                  ['link', 'image'],
                  ['blockquote', 'code-block'],
                ],
              }}
            />
          </Form.Item>

          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={loading}
              icon={<PlusOutlined />}
            >
              Edit Packing
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default EditPackingMode;
